<template>
    <v-app id="inspire">
        <Header type="search" />
        <v-main class="grey lighten-3">
            <v-container>
                <v-row>
                    <Menu />
                    <v-container class="col-10">
                        <v-row>
                            <v-col class="page-top d-flex justify-space-between" cols="12">
                                <div>
                                    <div class="page-title">Заявки</div>
                                    <div class="breadcrumb">Монитор продаж / Заявки</div>
                                </div>
                            </v-col>
                        </v-row>
                        <Block :padding="0">
                            <div class="filter">
                                <div class="top-line">
                                    <div class="left">
                                        <div class="w-352">
                                            <v-autocomplete colspan="1" :items="listClient ? listClient.client : []"
                                                item-value="client_id" item-text="name" placeholder="Поиск клиентов"
                                                no-data-text="Результатов не найдено" clearable color="#629F33"
                                                item-color="success" :search-input.sync="search" v-model="select" filled
                                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                                class="rounded-lg" append-icon="" hide-details outlined dense
                                                background-color="white">
                                                <template v-slot:prepend-inner>
                                                    <v-icon>mdi-magnify</v-icon>
                                                </template>
                                            </v-autocomplete>
                                        </div>
                                        <v-btn class="search-button" style="margin-top: 0 !important;">
                                            Создать клиента
                                        </v-btn>
                                    </div>
                                    <div class="right">
                                        <Grid :column="3" :gap="10" :customStyle="{ alignItems: 'center' }">
                                            <span class="toggle-label">Выводить по</span>
                                            <v-btn-toggle mandatory background-color="#FFFFFF" class="rounded-lg">
                                                <v-btn width="33%">
                                                    10
                                                </v-btn>
                                                <v-btn width="33%">
                                                    20
                                                </v-btn>
                                                <v-btn width="33%">
                                                    30
                                                </v-btn>
                                            </v-btn-toggle>
                                            <v-btn class="filter-btn" @click="showFilterGrid = !showFilterGrid">
                                                <Icon :iconName="showFilterGrid ? 'x' : 'filter'" width=" 16" height="16"
                                                    viewBox="0 0 16 16" strockeWidth="2" stroke="#fff" />
                                                Фильтр
                                            </v-btn>
                                        </Grid>
                                    </div>
                                </div>
                                <transition name="fade">
                                    <div class="hidden-block" v-if="showFilterGrid">
                                        <Grid :column="4" :gap="20" :customStyle="{ rowGap: 0 }">
                                            <div class="filter__field">
                                                <span class="label">
                                                    Название
                                                </span>
                                                <v-select class="rounded-lg custom__select" :items="[]" item-title="title"
                                                    item-value="value" item-text="title"
                                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                                    placeholder="Значение" append-icon="mdi-chevron-down" outlined dense>
                                                </v-select>
                                            </div>
                                            <div class="filter__field">
                                                <span class="label">
                                                    Название
                                                </span>
                                                <v-select class="rounded-lg custom__select" :items="[]" item-title="title"
                                                    item-value="value" item-text="title"
                                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                                    placeholder="Значение" append-icon="mdi-chevron-down" outlined dense>
                                                </v-select>
                                            </div>
                                            <div class="filter__field">
                                                <span class="label">
                                                    Название
                                                </span>
                                                <v-select class="rounded-lg custom__select" :items="[]" item-title="title"
                                                    item-value="value" item-text="title"
                                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                                    placeholder="Значение" append-icon="mdi-chevron-down" outlined dense>
                                                </v-select>
                                            </div>
                                            <div class="filter__field">
                                                <span class="label">
                                                    Название
                                                </span>
                                                <v-select class="rounded-lg custom__select" :items="[]" item-title="title"
                                                    item-value="value" item-text="title"
                                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                                    placeholder="Значение" append-icon="mdi-chevron-down" outlined dense>
                                                </v-select>
                                            </div>
                                            <div class="filter__field colspan-4 button-block">
                                                <v-btn class="apply">
                                                    Применить
                                                </v-btn>
                                                <v-btn class="clear">
                                                    Очистить
                                                </v-btn>
                                            </div>

                                        </Grid>
                                    </div>
                                </transition>
                            </div>
                            <TableBlock :darkHeader="true" :notBorderBottom="true" :borderTop="true">
                                <template v-slot:head>
                                    <tr>
                                        <th class="font-bold">Клиент</th>
                                        <th class="font-bold">Карта</th>
                                        <th class="font-bold">Статус</th>
                                        <th class="font-bold">Абонемент</th>
                                        <th class="font-bold">Дата начала</th>
                                        <th class="font-bold">Дата окончания</th>
                                        <th class="font-bold">Контакт</th>
                                        <th class="font-bold">Менеджер</th>
                                    </tr>
                                </template>
                                <template v-slot:body>
                                    <tr v-for="num in rows" :key="`row-${num}`">
                                        <td class="no-wrap">
                                            <div class="client">
                                                <div class="ava">
                                                    <img src="/playground_assets/Image-2.png" alt="">
                                                </div>
                                                Иванов Иван Иванович
                                            </div>
                                        </td>
                                        <td>
                                            Менеджер
                                        </td>
                                        <td>
                                            Новый
                                        </td>
                                        <td>
                                            Все включено 6 мес
                                        </td>
                                        <td>
                                            25.25.2999
                                        </td>
                                        <td>
                                            25.25.2999
                                        </td>
                                        <td>
                                            +7 900 000 00-00
                                        </td>
                                        <td>
                                            +7 900 000 00-00
                                        </td>
                                    </tr>

                                </template>
                            </TableBlock>
                            <div class="navigete">
                                <div class="information">
                                    Показано с 1 по 10 из 64 результатов
                                </div>
                                <div class="pagination">
                                    <transition name="fade">
                                        <v-btn variant="text" class="pagination-btn-icon left" v-if="notShowFirstPage"
                                            @click="changeListPage('prev')">
                                            <Icon iconName="chevron-left" width="24" height="24" viewBox="0 0 24 24"
                                                strocke="#629F33" strockeWidth="2" />
                                        </v-btn>
                                    </transition>
                                    <ul :class="{ 'list-end': listEnd }">
                                        <li v-for="p in pageShow" :key="`page-number-${p}`">
                                            <v-btn :class="{ 'pagination-btn': true, active: p == pageSelect }"
                                                @click="pageSelect = p">
                                                {{ p }}
                                            </v-btn>
                                        </li>
                                        <li class="etc">
                                            ...
                                        </li>
                                        <li>
                                            <v-btn :class="{ 'pagination-btn': true, active: pageSelect == maxPage }"
                                                @click="pageSelect = maxPage">
                                                {{ maxPage }}
                                            </v-btn>
                                        </li>
                                    </ul>
                                    <v-btn variant="text" class="pagination-btn-icon" @click="changeListPage('next')">
                                        <Icon iconName="chevron-left" width="24" height="24" viewBox="0 0 24 24"
                                            strocke="#629F33" strockeWidth="2" />
                                    </v-btn>
                                </div>
                            </div>
                        </Block>
                    </v-container>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>
<script>
import { globalMethods } from "@/mixins/globalMethods";
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
export default {
    name: 'Clients2',
    mixins: [globalMethods],
    components: {
        Header,
        Menu,
    },
    watch: {
        pageSelect: function (value) {
            if (value == 1) {
                this.$set(this, 'pageShow', [1, 2, 3, 4])
            } else if (value == this.maxPage) {

                let newShowPage = []
                for (let i = 1; i < 4; i++) {
                    newShowPage.push(this.maxPage - i)
                }
                this.$set(this, 'pageShow', [1, ...newShowPage.reverse()])
            }
        },
    },
    computed: {
        listEnd() {
            return this.pageSelect >= this.maxPage - 3 && this.pageShow[this.pageShow.length - 1] > 4
            // return this.pageShow[this.pageShow.length - 1] > 4
        },
        notShowFirstPage() {
            return this.pageShow[0] > 1 || this.pageShow[this.pageShow.length - 1] > 4
        }
    },
    data() {
        return {
            select: null,
            showFilterGrid: false,
            rows: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            pageSelect: 1,
            pageShow: [1, 2, 3, 4],
            maxPage: 24,
        }
    },
    methods: {
        changeListPage(type) {
            if (type == 'next') {
                let lastNumber = [...this.pageShow].pop()
                if (lastNumber == this.maxPage - 1) {
                    return false
                }
                let newShowPage = []
                if (lastNumber < this.maxPage - 4) {

                    for (let i = 1; i < 5; i++) {
                        newShowPage.push(++lastNumber)
                    }
                    this.$set(this, 'pageShow', newShowPage)
                } else {
                    for (let i = 1; i < 5; i++) {
                        newShowPage.push(this.maxPage - i)
                    }
                    this.$set(this, 'pageShow', newShowPage.reverse())
                }
            } else {
                let firstNumber = [...this.pageShow].shift(),
                    lastNumber = [...this.pageShow].pop()

                if (lastNumber - 3 != firstNumber) {
                    firstNumber = lastNumber - 2
                }
                if (firstNumber > 5) {
                    let newShowPage = []
                    for (let i = 1; i < 5; i++) {
                        newShowPage.push(--firstNumber)
                    }
                    newShowPage[newShowPage.length - 1] = 1
                    this.$set(this, 'pageShow', newShowPage.reverse())
                } else {
                    this.$set(this, 'pageShow', [1, 2, 3, 4])
                }
            }
        }
    }
}
</script>
<style scoped lang="scss">
.filter {
    padding: 20px;

    .top-line {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
            flex: 1;
            display: flex;
            align-items: center;

            .v-input__slot {
                border-radius: 12px;
            }
        }

        .right {
            .v-input__slot {
                border-radius: 12px;
            }

            .toggle-label {
                display: block;
                font-family: 'Circe';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 24px;
                text-align: right;
                width: 100%;
                color: #767676;
            }

            .v-btn-toggle {
                button {
                    &:first-child {
                        border-radius: 12px 0 0 12px;
                    }

                    &:last-child {
                        border-radius: 0 12px 12px 0;
                    }

                    background: #fff !important;

                    &::before {
                        display: none;
                    }
                }
            }
        }

        .w-352 {
            width: 352px;
        }

        .filter-btn {
            background: #A13453;
            border-radius: 12px;
            text-transform: none;
            color: #FFFFFF;
            font-family: 'Circe';
            font-style: normal;
            font-weight: 700;
            font-size: 16px;
            line-height: 24px;
            box-shadow: none;
            padding: 13px 21px;

            svg {
                margin-right: 5px;
            }
        }

    }

    .hidden-block {
        padding-top: 20px;

    }

    &__field {
        &.colspan-4 {
            grid-column: 1 / 5;
        }

        &.button-block {
            button {
                &:not(:last-child) {
                    margin-right: 20px;
                }
            }
        }

        .label {
            color: #1A1A1A;
            display: block;
            margin-bottom: 8px;
            font-family: 'Circe';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
        }
    }

    button {
        border-radius: 12px;
        text-transform: none;
        color: #FFFFFF;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        box-shadow: none;
        padding: 13px 21px;

        &.apply {
            background: #629F33 !important;
            color: #fff !important;
        }

        &.clear {
            background: #F1F1F1 !important;
            color: #1A1A1A !important;
        }

    }
}

.min-w-173 {
    min-width: 173px;
}

.client {
    display: flex;
    align-items: center;

    .ava {
        margin-right: 8px;
    }
}

.navigete {
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .information {
        font-family: 'Circe';
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 16px;
        color: #767676;
    }

    .pagination {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        ul {
            list-style: none;
            display: flex;
            align-items: center;
            margin-right: 29px;

            &.list-end {
                li {
                    &.etc {
                        order: 1;
                    }
                }
            }

            li {
                &:not(:last-child) {
                    margin-right: 29px;
                }

                &:nth-child(1) {
                    order: 1;
                }

                &:nth-child(2) {
                    order: 2;
                }

                &:nth-child(3) {
                    order: 3;
                }

                &:nth-child(4) {
                    order: 4;
                }

                &.etc {
                    order: 5;
                    -webkit-touch-callout: none;
                    /* iOS Safari */
                    -webkit-user-select: none;
                    -khtml-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                }

                &:nth-child(6) {
                    order: 6
                }

                .pagination-btn {
                    width: 32px !important;
                    max-width: 32px !important;
                    min-width: 32px !important;
                    height: 32px !important;
                    max-height: 32px !important;
                    min-height: 32px !important;
                    background: #fff !important;
                    box-shadow: none !important;
                    font-family: 'Circe';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 13px;
                    line-height: 16px;
                    color: #629F33 !important;
                    border-radius: 50%;

                    &.active {
                        color: #fff !important;
                        background: #629F33 !important;
                    }
                }
            }

        }

        .pagination-btn-icon {
            width: 24px !important;
            max-width: 24px !important;
            min-width: 24px !important;
            height: 24px !important;
            max-height: 24px !important;
            min-height: 24px !important;
            background: #fff !important;
            box-shadow: none !important;
            font-family: 'Circe';
            font-style: normal;
            font-weight: 700;
            font-size: 13px;
            line-height: 16px;
            color: #629F33 !important;
            border-radius: 50%;

            &.left {
                -moz-transform: scale(-1, -1);
                -o-transform: scale(-1, -1);
                -webkit-transform: scale(-1, -1);
                transform: scale(-1, -1);
            }

        }
    }
}
</style>